export default "__VITE_ASSET__CrRAUJS4__"